/* eslint-disable react/no-danger */
import React, { useEffect } from 'react'

function GoogleRatingBadge() {
  useEffect(() => {
    const script = document.createElement('script')
    script.innerHTML = `
    window.renderBadge = function() {
      const ratingBadgeContainer = document.createElement("div");
        document.body.appendChild(ratingBadgeContainer);
        window.gapi.load('ratingbadge', function() {
          window.gapi.ratingbadge.render(
            ratingBadgeContainer, {
              // REQUIRED
              "merchant_id": 5476661094,
              // OPTIONAL
              "position": "BOTTOM_LEFT"
            });           
      });
    }
  `
    document.body.appendChild(script)
  }, [])

  return <></>
}

export default GoogleRatingBadge
